<template>
  <Toolbar>
    <template #left>
      <span class="lang"> Language: </span>
      <SelectLanguage showLabel="true" />
    </template>
    <template #right>
      iZi Co., Ltd
    </template>
  </Toolbar>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
@Options({})
export default class Footer extends Vue {
  Pin = "";
}
</script>

<style lang="scss">
.left-header-login {
  align-self: center;
}
.lang {
  margin-right: 10px;
}
.action-join {
  align-self: center;
}
</style>
